<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <div class="u-f u-ac u-jsb">
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" :height="height" border v-loading="loading">
                <el-table-column prop="id" label="编号" width="70"></el-table-column>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="min_price" label="最低价格"></el-table-column>
                <el-table-column prop="start_time" label="生效日期"></el-table-column>
                <el-table-column prop="end_time" label="失效日期"></el-table-column>
                <el-table-column prop="total" label="总数"></el-table-column>
                <el-table-column prop="fraction" label="类型">
                    <template slot-scope="scope">
                        <span>{{({1:'满减',0:'折扣'})[scope.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="状态">
                    <template slot-scope="scope">
                        <span>{{({1:'不生效',0:'生效'})[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="value" label="值"></el-table-column>
                <el-table-column prop="growth_value" label="是否所有用户可领取">
                    <template slot-scope="scope">
                        <span>{{({1:'是',0:'否'})[scope.row.show_cardcenter]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="使用渠道">
                    <template slot-scope="scope">
                        <span>{{({1:'通用',3:'抽奖专用'})[scope.row.use_channel]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="growth_value" label="赠送">
                    <template slot-scope="scope">
                        <span>
                            <el-button type="text" @click="zsyhq(scope.row)">选择用户</el-button>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <el-dialog title="优惠券设置" :visible.sync="dialogVisible" center top="20px" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="优惠券名称" prop='name'>
                        <el-input v-model="ruleForm.name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="是否生效" prop='status'>
                        <el-select v-model="ruleForm.status" placeholder="请选择" size="small">
                            <el-option v-for="item in state_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型" prop='type'>
                        <el-select v-model="ruleForm.type" placeholder="请选择" size="small">
                            <el-option v-for="item in type_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="使用渠道">
                        <el-radio-group v-model="ruleForm.use_channel" @change="selectusechannel">
                            <el-radio :label="1">通用</el-radio>
                            <el-radio :label="3">抽奖专用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="总数" prop='total'>
                        <el-input v-model="ruleForm.total" size="small" placeholder="总数(0不限制)"
                            :disabled='ruleForm.use_channel==3'></el-input>
                    </el-form-item>
                    <el-form-item label="最低价" prop='min_price'>
                        <el-input v-model="ruleForm.min_price" size="small" placeholder="最小金额（0不限金额）"></el-input>
                    </el-form-item>
                    <el-form-item label="值" prop='value'>
                        <el-input v-model="ruleForm.value" size="small" placeholder="折扣值，满减券最大减免金额，折扣券减免比例"></el-input>
                    </el-form-item>
                    <el-form-item label="到期类型">
                        <el-radio-group v-model="ruleForm.expire_type" @change="changeexpire_type">
                            <el-radio :label="1" :disabled='ruleForm.use_channel==3'>指定时间</el-radio>
                            <el-radio :label="2" :disabled='ruleForm.use_channel==3'>指定领取后天数</el-radio>
                            <el-radio :label="3">不限</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <template v-if="ruleForm.expire_type!=3">
                        <el-form-item label="领取后到期天数" v-if="ruleForm.expire_type==2" prop="expire_day">
                            <el-input type="number" size="small" v-model="ruleForm.expire_day" min="0">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="开始日期" prop="start_time"
                            :rules="[{required:ruleForm.expire_type==1,message:'请选择开始日期',trigger:'blur'}]">
                            <el-date-picker v-model="ruleForm.start_time" type="date" size="small"
                                value-format="yyyy-MM-dd" placeholder="选择开始日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期" prop="end_time"
                            :rules="[{required:ruleForm.expire_type==1,message:'请选择结束日期',trigger:'blur'}]">
                            <el-date-picker v-model="ruleForm.end_time" type="date" size="small"
                                value-format="yyyy-MM-dd" placeholder="选择结束日期">
                            </el-date-picker>
                        </el-form-item>

                    </template>


                    <el-form-item label="排序" prop="sort">
                        <el-input placeholder="请输入内容" type="number" size="small" v-model="ruleForm.sort">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ruleForm.remork">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="是否可领取(所有用户)">
                        <el-radio-group v-model="ruleForm.show_cardcenter">
                            <el-radio :label="1" :disabled='ruleForm.use_channel==3'>是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>


                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 选择用户 -->
        <el-dialog title="选择用户" width="80%" :visible.sync="zsdialoged" @close='closedialo' top="20px" center
            class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="选择用户">
                        <div class="u-f u-ac">
                            <el-form-item>
                                <el-input v-model="userkeyword" placeholder="请输入昵称、手机号" style="width:200px" clearable
                                    size="small"></el-input>
                            </el-form-item>
                            <!-- <div class="pd">
                                <el-form-item>
                                    <el-select v-model="lb_value" clearable placeholder="请选择人员类型" size="small"
                                        filterable>
                                        <el-option v-for="item in  lb_options" :key="item.id" :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div> -->
                            <!-- <el-form-item v-if="sendradio==1">
                                <span style="color:red;padding:5px 0;font-size:13px">(选择发送给所属类别人员)</span>
                            </el-form-item> -->
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" size="small" @click="searchusers">搜索
                                </el-button>
                                <!-- <span style="color:red;padding:5px 0;font-size:13px">(不选则全体活动)</span> -->
                            </el-form-item>

                            <el-form-item label="赠送数量">
                                <el-input v-model="zs_count" placeholder="请输入赠送数量" style="width:200px" min="1"
                                    size="small" type="number"></el-input>
                            </el-form-item>

                        </div>
                        <div class="u-f">
                            <div style="width:50%">
                                <el-table :data="userTableData" border v-loading="loading" height="430"
                                    ref="configurationTables" @selection-change="handleSelectionChange"
                                    :row-key="getRowKeys">
                                    <el-table-column type="selection" width="55" :reserve-selection="true" />
                                    <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                                        <template slot-scope="scope">
                                            <img :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                                alt="" width="50" class="tablimg">
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="u-f u-ac u-jsb ft_mr">
                                    <div></div>
                                    <div>
                                        <el-pagination @size-change="userhandleSizeChange"
                                            @current-change="userhandleCurrentChange" :current-page="usercurrentPage"
                                            :page-sizes="[10, 20, 30, 40]" :page-size="userpagesize"
                                            layout="total, sizes, prev, pager, next" :total="usercount">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                            <div style="width:50%;margin-left:10px">
                                <el-table :data="sendusers" border v-loading="loading" height="430"
                                    ref="configurationTable">
                                    <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                                        <template slot-scope="scope">
                                            <img :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                                alt="" width="50" class="tablimg">
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited()" :loading='sendloading' size="small">确 定</el-button>
                <el-button @click="zsdialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 10,
                count: 0,
                height: null,
                // 
                eid: '',
                dialogVisible: false,
                subloading: false,
                sendloading: false,
                ruleForm: {
                    end_time: '',
                    start_time: '',
                    value: '',
                    min_price: 0,
                    total: 0,
                    type: 1,
                    status: 0,
                    name: '',
                    remork: '',

                    sort: 50,
                    expire_day: 0,
                    expire_type: 1,
                    show_cardcenter: 0,
                    use_channel: 1
                },

                rule: {
                    name: [{
                        required: true,
                        message: '请填写名称',
                        trigger: 'blur'
                    }],
                    status: [{
                        required: true,
                        message: '请选择是否生效',
                        trigger: 'blur'
                    }],
                    type: [{
                        required: true,
                        message: '请选择类型',
                        trigger: 'blur'
                    }],
                    total: [{
                        required: true,
                        message: '请填写优惠券总数',
                        trigger: 'blur'
                    }],
                    min_price: [{
                        required: true,
                        message: '请填写优惠券最低价',
                        trigger: 'blur'
                    }],
                    value: [{
                        required: true,
                        message: '请填写值',
                        trigger: 'blur'
                    }],
                    // start_time: [{
                    //     required: true,
                    //     message: '请选择开始时间',
                    //     trigger: 'blur'
                    // }],
                    // end_time: [{
                    //     required: true,
                    //     message: '请选择结束时间',
                    //     trigger: 'blur'
                    // }],
                    expire_day: [{
                        required: true,
                        message: '请填写过期天数',
                        trigger: 'blur'
                    }],
                    sort: [{
                        required: true,
                        message: '请填写排序',
                        trigger: 'blur'
                    }],
                },
                state_options: [{
                        id: 1,
                        name: '不生效'
                    },
                    {
                        id: 0,
                        name: '生效'
                    },
                ],
                type_options: [{
                        id: 1,
                        name: '满减'
                    },
                    {
                        id: 2,
                        name: '折扣'
                    },
                ],
                zsdialoged: false,
                userTableData: [],
                loading: false,
                usercurrentPage: 1,
                userpagesize: 10,
                usercount: 0,
                sendusers: [],
                userkeyword: '',
                lb_value: '',
                zs_count: 1

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios.post(`/admin/pc/inquiry/coupon/couponList`, {
                        page: this.currentPage,
                        page_count: this.pagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm = {
                    end_time: '',
                    start_time: '',
                    value: '',
                    min_price: 0,
                    total: 0,
                    type: 1,
                    status: 0,
                    name: '',
                    remork: '',

                    sort: 50,
                    expire_day: 0,
                    expire_type: 1,
                    show_cardcenter: 0,
                    use_channel: 1
                }
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid) {
                            urls = `/admin/pc/inquiry/coupon/couponUpdate`
                        } else {
                            urls = "/admin/pc/inquiry/coupon/create"
                        }
                        axios.post(urls, {
                                id: this.eid,
                                ...that.ruleForm
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                this.ruleForm.end_time = row.end_time
                this.ruleForm.start_time = row.start_time
                this.ruleForm.value = row.value
                this.ruleForm.min_price = row.min_price
                this.ruleForm.total = row.total
                this.ruleForm.type = row.type
                this.ruleForm.status = row.status
                this.ruleForm.name = row.name
                this.ruleForm.remork = row.remork
                this.ruleForm.sys_default = row.sys_default
                this.ruleForm.use_channel = row.use_channel
                this.ruleForm.sort = row.sort
                this.ruleForm.expire_day = row.expire_day
                this.ruleForm.expire_type = row.expire_type
                this.ruleForm.show_cardcenter = row.show_cardcenter

            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post(`/admin/pc/inquiry/coupon/couponDel`, {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            zsyhq(row) {
                this.zsdialoged = true
                this.eid = row.id
                this.searchusers()
            },
            closedialo() {
                this.userkeyword = ''
                this.sendusers = []
                this.$nextTick(() => {
                    this.$refs.configurationTables.clearSelection();
                })
            },
            searchusers() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/User/userList", {
                        page: that.usercurrentPage,
                        page_count: that.userpagesize,
                        keyword: this.userkeyword,
                        customer_type: this.lb_value

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.userTableData = response.data.data.list
                        that.usercount = response.data.data.totalCount

                    })
                    .catch(error => {})
            },
            handleSelectionChange(val) {
                this.sendusers = val;
            },
            getRowKeys(row) {
                return row.id; // id为列表数据的唯一标识
            },
            userhandleSizeChange(val) {
                let that = this
                that.userpagesize = val;
                that.searchusers()
            },
            userhandleCurrentChange(val) {
                let that = this
                that.usercurrentPage = val;
                that.searchusers()
            },
            async submited() {
                let userids = this.sendusers.map(ele => ele.id);
                if (userids.length == 0) return this.$message.error('请选择用户')
                if (!this.zs_count || this.zs_count == 0) return this.$message.error('数量必须大于0')
                this.sendloading = true
                let res = await this.ajax('inquiry/coupon/couponGive', {
                    coupon_id: this.eid,
                    user_ids: userids,
                    count: this.zs_count,
                    type:2
                })
                if (res.code == 200) {
                    this.$message.success('赠送成功')
                    this.zsdialoged = false
                } else {
                    this.$message(res.msg)
                }
                this.sendloading = false

            },
            changeexpire_type() {
                if (this.ruleForm.expire_type == 1) {
                    this.ruleForm.expire_day = 0
                }
                if (this.ruleForm.expire_type == 3) {
                    this.ruleForm.expire_day = 0
                    this.ruleForm.start_time = ''
                    this.ruleForm.end_time = ''
                }
            },
            selectusechannel(n) {
                if (n == 3) {
                    this.ruleForm.total = 0
                    this.ruleForm.expire_type = 3
                    this.ruleForm.expire_day = 0
                    this.ruleForm.start_time = ''
                    this.ruleForm.end_time = ''
                    this.ruleForm.show_cardcenter = 0
                }
            },
        },

    };
</script>


<style scoped>
</style>